module.exports = "https://lijc.rightinthebox.com/promotion_src/public/optimus-eechic-online/9d06f2b0/_next/static/images/pc_cart_empty_20b2cc.png";